// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__r0+NA","footerBrand":"Footer_footerBrand__2hsMw","footerBrandIcon":"Footer_footerBrandIcon__NYWH5","footerBottom":"Footer_footerBottom__P9X+M"};